import { Client } from "~/api/client";

const uri = import.meta.env.VITE_APP_BFF_URL;

if (!uri) throw new Error("VITE_APP_BFF_URL is not set");

const client: Client = new Client(`${window.location.origin}/${uri}`);

export { client };
